import React from 'react';

import messages from './messages';
import { ChildrenPropType } from '../../../prop-types/children';
import { OrderDetailsSectionId } from '../fulfillment-plan/order-details-expanded-section-provider';
import ExpanderSection from '../tab-section/expander-section/expander-section';
import SectionTitle from '../tab-section/title';

import style from './section.module.less';

const OrderDetailsFulfillmentDisplaySection = ({ children }) => {
  return (
    <ExpanderSection
      ariaLabelMessageDescriptor={messages.sectionAriaLabel}
      contentClassName={style['fulfillment-display-section']}
      headerContent={<SectionTitle messageDescriptor={messages.shipmentRecordSectionTitle} />}
      sectionContent={children}
      sectionId={OrderDetailsSectionId.ConfigureShipment}
    />
  );
};

export default OrderDetailsFulfillmentDisplaySection;

OrderDetailsFulfillmentDisplaySection.propTypes = {
  children: ChildrenPropType.isRequired,
};
